export default "__VITE_ASSET__Com7Ook$__"